<div class="container-div">
    <div class="title-div" *ngIf="!this.showRelogin">Session Expiring Soon</div>
    <div class="title-div" *ngIf="this.showRelogin">Session Expired</div>
    <div class="subtitle-div">{{alertMessage}}</div>
    <div class="modal-footer">
        <button *ngIf="!this.showRelogin" (click)="logout()" class="btn-primary cancel-button" style="margin-right: 10px;">Logout</button>
        <button *ngIf="!this.showRelogin" (click)="extend()" class="btn-secondary ok-button" >Extend</button>
        <button *ngIf="this.showRelogin" (click)="logout()" class="btn-secondary ok-button" >Return to login</button>
    </div>
</div>